import React, { useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import useInactivityTimeout from '../hooks/useInactivityTimeout';
import SessionTimeoutModal from './SessionTimeoutModal';

const SessionManager = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);

  const handleTimeout = useCallback(async () => {
    console.log('⏰ Session timeout triggered');
    setShowTimeoutModal(true);
    await logout();
  }, [logout]);

  const handleModalClose = useCallback(() => {
    setShowTimeoutModal(false);
    navigate('/login', { replace: true });
  }, [navigate]);

  // Only activate timeout for authenticated users and not on login/register pages
  const isPublicRoute = ['/login', '/register', '/'].includes(location.pathname);
  const shouldTrackInactivity = user && !isPublicRoute;

  useInactivityTimeout(
    shouldTrackInactivity ? handleTimeout : () => {},
    300000 // 5 minutes (300 seconds)
  );

  return (
    <>
      {children}
      <SessionTimeoutModal 
        isOpen={showTimeoutModal} 
        onClose={handleModalClose} 
      />
    </>
  );
};

export default SessionManager;
